<div class="shared-modal-recipients-container">

  <div class="modal-header">
    <div class="modal-toolbar">
      <div class="modal-title-container">
        <div>
          <div>{{ modalTitle }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="app-content">
    <div class="context-header-container">
      <ng-container>
        <app-display-icon
          [colour]="iconColour"
          [icon]="icons.infoSlabCircleOutline"
          class="title-icon">
        </app-display-icon>
      </ng-container>
      <ng-container>
        <div>Email Recipients for {{ order.supplierId }}</div>
      </ng-container>
    </div>

    <div class="context-description-container">
      <ng-container>

        @if (
          order.emailStatus === autoOrderAllStatusTypesEnum.FAILED &&
          (orderErrorMsgObject || orderErrorMsgString)
          ) {
          <div class="email-failed">
            <div class="bold">
              An error occurred while attempting to send the email:
            </div>

            @if (orderErrorMsgObject) {
              <div>
                @if (orderErrorMsgObject.code) {
                  <div>Error: {{ orderErrorCode }}</div>
                }

                @if (orderErrorMsgObject.message) {
                  <div>Message: {{ orderErrorMsgObject.message }}</div>
                }
              </div>
            }

            @if (orderErrorMsgString) {
              <div>
                {{ orderErrorMsgString }}
              </div>
            }
          </div>
        }
        <div>Please note: Changes to recipients here will update the recipients for this order and not for the
          supplier.
        </div>
        @if (order.emailStatus === 'SKIP') {
          <div>Sending emails on this order have been skipped.</div>
        }
        <div></div>
        <br />
        <div>The following are the recipients on the order:</div>
        @if (recipients.length > 0 || getNewRecipientsArray.length > 0) {
          @for (email of recipients; track $index; ) {
            <div class="email-recipient" [class.email-recipient--invalid]="!isEmailValid(email)">
              <div class="email-recipient-address">
                @if (!isEmailValid(email)) {
                  <app-display-icon
                    [colour]="iconColourEnum.red"
                    [icon]="icons.alertRhombusOutline"
                    [tooltip]="'Invalid email address — correct or delete'">
                  </app-display-icon>
                }
                <span>{{ email }}</span>
              </div>
              @if (!getCanRecipientBeDeleted()) {
                <app-display-icon
                  [colour]="iconColourEnum.white"
                  [icon]="icons.checkAll"
                  [tooltip]="order.emailStatus === autoOrderAllStatusTypesEnum.SENT
                  ? 'This email has successfully been sent'
                  : 'Sending of this email is ' + autoOrderAllStatusTypesEnum.PENDING">
                </app-display-icon>
              }
              @if (getCanRecipientBeDeleted()) {
                <app-display-icon
                  (click)="onRecipientDelete($index)"
                  [colour]="iconColourEnum.red"
                  [icon]="icons.deleteOutline"
                  [tooltip]="'Delete ' + email">
                </app-display-icon>
              }
            </div>
          }
        } @else {
          <div class="no-recipients">
            <div>There are no recipients selected.</div>
          </div>
        }
      </ng-container>

      @if (getNewRecipientsArray.length > 0) {
        <div class="new-recipients">The following are the new recipients:
          @for (emailCtrl of getNewRecipientsControlArray; track $index) {
            <div [formGroup]="recipientForm" class="email-recipient">
              <div
                class="new-recipient-input-wrapper"
                [class.new-recipient-input-wrapper--invalid]="emailCtrl.invalid && emailCtrl.dirty">
                <input
                  class="new-recipient-input"
                  type="email"
                  placeholder="Enter additional email"
                  [formControl]="emailCtrl"
                />
                @if (emailCtrl.invalid && emailCtrl.dirty) {
                  <span class="new-recipient-error">Enter a valid email address</span>
                }
              </div>
              <app-display-icon
                (click)="onRecipientDeleteFromNew($index)"
                [colour]="iconColourEnum.red"
                [icon]="icons.deleteOutline"
                [tooltip]="'Delete ' + emailCtrl.value">
              </app-display-icon>
            </div>
          }
        </div>
      }

    </div>

  </div>

  <div class="footer">
    <app-shared-button
      (buttonClicked)="onClose()"
      [colour]="'clear'"
      [fill]="false">
      Close
    </app-shared-button>

    <!-- SKIP SENDING EMAILS-->
    @if (order.emailStatus === autoOrderAllStatusTypesEnum.FAILED) {
      <app-shared-button
        (buttonClicked)="onSkipEmailsClick()"
        [fill]="true">
        Skip Emails
      </app-shared-button>
    }

    <!-- SAVE NEW RECIPIENTS  -->
    @if (getNewRecipientsArray.length > 0) {
      <app-shared-button
        (buttonClicked)="onSaveRecipientsClick()"
        [disabled]="getIsFormValid"
        [fill]="true"
        [matTooltip]="'Save New Recipients Only'">
        Save
      </app-shared-button>
    }

    <!-- SAVE NEW AND SEND EMAILS TO ALL RECIPIENTS  -->
    @if (getNewRecipientsArray.length > 0) {
      <app-shared-button
        (buttonClicked)="onSaveAndSendNewEmails()"
        [disabled]="order.pdfStatus === autoOrderAllStatusTypesEnum.FAILED || getIsFormValid"
        [fill]="true"
        [matTooltip]="order.pdfStatus === autoOrderAllStatusTypesEnum.FAILED
        ? 'You can not save new recipients if the PDF status is FAILED'
        : 'Save new recipients and Send Emails to All Recipients'">
        Save and Send
      </app-shared-button>
    }

    <!-- SEND EMAILS TO CURRENT SAVED RECIPIENTS -->
    @if (getNewRecipientsArray.length < 1) {
      <app-shared-button
        (buttonClicked)="onResendEmails()"
        [disabled]="recipients.length < 1 || order.pdfStatus === autoOrderAllStatusTypesEnum.FAILED || getIsFormValid"
        [fill]="true"
        [matTooltip]="getButtonSendEmailsTooltip">
        Send Emails
      </app-shared-button>
    }

    <!-- ADD ADDITIONAL RECIPIENTS -->
    <app-shared-button
      (buttonClicked)="onRecipientAdd()"
      [fill]="true"
      [matTooltip]="'Add Additional Recipients'">
      Add Recipient
    </app-shared-button>
  </div>

</div>
